<template class="page-component__scroll el-scrollbar__wrap">
  <div>
    <div class="icon">
      <img :src="require('@/assets/logo.png')">
      <!--      <div class="n1">实名证照</div>-->
      <!--      <div class="n2">Real-name License</div>-->
    </div>
    <div class="menu">
      <el-menu router default-active="1" class="el-menu-demo" mode="horizontal" @select="handleSelect">
        <el-menu-item index="1" route="/"><a href="javascript:;">{{$t('el.d.header_home')}}</a></el-menu-item>
        <el-menu-item index="2" route="/partner"><a href="javascript:;">{{$t('el.d.header_partner')}}</a></el-menu-item>
        <el-menu-item index="3" route="/about"><a href="javascript:;">{{$t('el.d.header_about')}}</a></el-menu-item>
        <el-menu-item @click="changeLang"><a
          href="javascript:;">{{$t('el.d.header_lang1')}}/{{$t('el.d.header_lang2')}}</a></el-menu-item>
        <!--          <el-dropdown @command="changeLang" trigger="click">-->
        <!--            <span class="el-dropdown-link">-->
        <!--             {{$t('el.d.header_lang1')}}<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i>-->
        <!--            </span>-->
        <!--            <el-dropdown-menu slot="dropdown">-->
        <!--              <el-dropdown-item command="zh_cn">{{$t('el.d.header_lang1')}}</el-dropdown-item>-->
        <!--              <el-dropdown-item command="en">{{$t('el.d.header_lang2')}}</el-dropdown-item>-->
        <!--            </el-dropdown-menu>-->
        <!--          </el-dropdown>-->
        <el-menu-item disabled><a href="javascript:;">{{$t('el.d.header_login')}}</a></el-menu-item>
        <el-button type="primary" @click="mpShow = true" round>{{$t('el.d.header_attMp')}}</el-button>
      </el-menu>
    </div>
    <div class="menuTel">
      <el-menu router="true" :collapse="true">
        <el-submenu index="1" style="background-color: #F5F5F5">
          <template slot="title">
            <img :src="require('@/assets/menu_2x.png')" style="width: 23px;height: 23px;border: none">
          </template>
          <el-menu-item-group>
            <el-menu-item index="1-1" route="/"><a href="javascript:;">{{$t('el.d.header_home')}}</a></el-menu-item>
            <el-menu-item index="1-2" route="/partner"><a href="javascript:;">{{$t('el.d.header_partner')}}</a>
            </el-menu-item>
            <el-menu-item index="1-3" route="/about"><a href="javascript:;">{{$t('el.d.header_about')}}</a>
            </el-menu-item>
            <el-menu-item @click="changeLang"><a href="javascript:;">{{$t('el.d.header_lang1')}}/{{$t('el.d.header_lang2')}}</a>
            </el-menu-item>
            <el-menu-item index="1-5" disabled><a href="javascript:;">{{$t('el.d.header_login')}}</a></el-menu-item>
            <el-menu-item @click="mpShow = true"><a href="javascript:;">{{$t('el.d.header_attMp')}}</a></el-menu-item>
          </el-menu-item-group>
        </el-submenu>
      </el-menu>
    </div>
    <el-dialog :visible.sync="mpShow" width="250px" top="30vh">
      <el-image
        :src="require('@/assets/mp_2x.png')"
        fit="fill">
      </el-image>
    </el-dialog>
    <div class="buttomMpDivPC">
      {{$t('el.d.header_attMp_fast')}}
      <el-image
        :src="require('@/assets/mp_2x.png')"
        fit="fill">
      </el-image>
      <el-image
        class="toUpBtn"
        @click="backTop"
        :src="require('@/assets/up.png')"
        fit="fill">
      </el-image>
    </div>
    <div class="buttomMpDivPhone">
      <el-image
        @click="mpShow = true"
        :src="require('@/assets/mp_2x.png')"
        fit="fill">
      </el-image>
      <el-image
        @click="backTop"
        class="toUpBtn"
        :src="require('@/assets/up.png')"
        fit="fill">
      </el-image>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Header',
    data () {
      return {
        mpShow: false,
      }
    },
    mounted () {
      window.addEventListener('scroll', this.scrollToTop)
    },
    destroyed () {
      window.removeEventListener('scroll', this.scrollToTop)
    },
    methods: {
      handleSelect (key, keyPath) {
        console.log(key, keyPath)
      },
      changeLang () {
        let curLang = this.$curLang === 'en' ? 'zh_cn' : 'en'
        this.$curLang = curLang
        this.$i18n.locale = curLang
        return false
      },
      backTop () {
        const that = this
        let timer = setInterval(() => {
          let ispeed = Math.floor(-that.scrollTop / 5)
          document.documentElement.scrollTop = document.body.scrollTop = that.scrollTop + ispeed
          if (that.scrollTop === 0) {
            clearInterval(timer)
          }
        }, 16)
      },
      scrollToTop () {
        const that = this
        let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        that.scrollTop = scrollTop
        if (that.scrollTop > 60) {
          that.btnFlag = true
        } else {
          that.btnFlag = false
        }
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Header.vue